import React from 'react';

interface Gym3DIconProps {
  size?: number;
  color?: string;
}

export const Gym3DIcon = ({ size = 48, color = '#8B5CF6' }: Gym3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 40);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="20" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Platform / floor */}
      <rect x="10" y="52" width="44" height="4" rx="2" fill={darkerColor} />
      <rect x="10" y="50" width="44" height="4" rx="2" fill={color} />
      {/* Barbell bar */}
      <rect x="8" y="38" width="48" height="3" rx="1.5" fill={lighterColor} />
      <rect x="8" y="39" width="48" height="3" rx="1.5" fill={color} />
      {/* Left weight plate */}
      <rect x="6" y="30" width="8" height="18" rx="2" fill={color} />
      <path d="M14 30 L16 28 L16 46 L14 48 Z" fill={darkerColor} />
      <rect x="10" y="32" width="5" height="14" rx="1" fill={darkerColor} />
      <rect x="8" y="32" width="5" height="14" rx="1" fill={color} />
      {/* Right weight plate */}
      <rect x="50" y="30" width="8" height="18" rx="2" fill={color} />
      <path d="M58 30 L60 28 L60 46 L58 48 Z" fill={darkerColor} />
      <rect x="46" y="32" width="5" height="14" rx="1" fill={color} />
      <path d="M51 32 L53 30 L53 44 L51 46 Z" fill={darkerColor} />
      {/* Person - legs */}
      <rect x="24" y="42" width="4" height="10" rx="1" fill={darkerColor} />
      <rect x="34" y="42" width="4" height="10" rx="1" fill={darkerColor} />
      {/* Person - torso bent forward */}
      <path d="M26 28 L36 28 L38 42 L24 42 Z" fill={color} />
      <path d="M36 28 L38 26 L40 40 L38 42 Z" fill={darkerColor} />
      {/* Person - arms reaching down to bar */}
      <rect x="22" y="28" width="3" height="12" rx="1" fill={color} transform="rotate(-5, 23, 34)" />
      <rect x="37" y="28" width="3" height="12" rx="1" fill={darkerColor} transform="rotate(5, 38, 34)" />
      {/* Person - head */}
      <circle cx="31" cy="24" r="5" fill={color} />
      <circle cx="32" cy="23" r="5" fill={lighterColor} />
      {/* Shine highlights */}
      <rect x="9" y="34" width="2" height="6" rx="1" fill="white" opacity="0.2" />
      <rect x="51" y="34" width="2" height="6" rx="1" fill="white" opacity="0.2" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
